// Column sizing for a result table. The table is only as wide as its columns, so
// its values sit beside the labels they belong to instead of at the far edge of a
// wide window. When the window is narrower than the table, the first column stays
// pinned and the rest scroll.

/** Width of each value column (a population's results). */
export const VALUE_COLUMN_WIDTH_PX = 160;

const CHARACTERISTIC_MIN_WIDTH_PX = 200;
const CHARACTERISTIC_MAX_WIDTH_PX = 440;
// Average glyph width of the table's body text, with room for cell padding. An
// estimate rather than a measurement: a fixed table layout needs the width up front.
const CHARACTER_WIDTH_PX = 7;
const CELL_PADDING_PX = 40;

/**
 * Width of the first (characteristic) column: enough for the longest label on one
 * line, within a floor and a cap. A label past the cap wraps inside its cell.
 */
export const getCharacteristicColumnWidthPx = (labels: string[]): number => {
  const longestLabelLength = labels.reduce((longest, label) => Math.max(longest, label.length), 0);
  const widthPx = longestLabelLength * CHARACTER_WIDTH_PX + CELL_PADDING_PX;
  return Math.min(Math.max(widthPx, CHARACTERISTIC_MIN_WIDTH_PX), CHARACTERISTIC_MAX_WIDTH_PX);
};

/** Total width of a table with the given first-column width and value columns. */
export const getTableWidthPx = (characteristicWidthPx: number, valueColumnCount: number): number =>
  characteristicWidthPx + VALUE_COLUMN_WIDTH_PX * valueColumnCount;
